import React from 'react';

import { LabelValue, LabelValueTypeConfig } from './Content.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function Signature(props) {
    let label, descriptionContent, value;
    if (props.config && props.config.config) {
        const blockProps = props.config.config.Block || {};
        if (blockProps.count != '1' && props.config.config.Label) {
            const config = { ...props.config.config.Label };
            if (props.label != undefined) {
                config.design = props.label;
            }
            label = TypeConfig.processLineOptions(config, blockProps.displayType);
        }
        if (blockProps.count == '3' && props.config.config.Description) {
            const config = { ...props.config.config.Description };
            if (props.descriptionContent != undefined) {
                config.design = props.descriptionContent;
            }
            descriptionContent = TypeConfig.processLineOptions(config, blockProps.displayType);
        }
        if (props.config.config.Value) {
            const config = { ...props.config.config.Value };
            if (props.content != undefined) {
                config.design = props.content;
            }
            value = TypeConfig.processLineOptions(config, blockProps.displayType);
        }
    }
    return <LabelValue {...props} descriptionContent={descriptionContent} label={label} value={value} />
}

const TypeConfig = {
    _addLineOptions: (blockConfig) => {
        const group = blockConfig.group;
        for (let i = 0; i < blockConfig.options.length; i++) {
            if (blockConfig.options[i].name != 'design') {
                continue;
            }
            blockConfig.options.splice(i + 1, 0,
                {
                    display: 'Label Spacing',
                    fullWidth: true,
                    group,
                    max: '100',
                    name: 'labelSpacing',
                    options: _TypeConfig.dropdown.measurement(),
                    type: 'measurement-slider',
                    value: { "unit": "px", "value": "5" }
                },
                {
                    display: 'Line Color',
                    group,
                    name: 'lineColor',
                    type: 'color-left'
                },
                {
                    display: 'Line Width',
                    group,
                    name: 'lineWidth',
                    options: _TypeConfig.dropdown.measurement(),
                    type: 'measurement',
                    value: { "unit": "px", "value": "1" }
                },
                {
                    display: 'Extend Line Below Content',
                    fullWidth: true,
                    group,
                    name: 'extendLine',
                    type: 'checkbox',
                    value: false
                }
            );
            break;
        }
        return blockConfig;
    },
    panel: {
        block: (firstPageOnly) => {
            const blockConfig = LabelValueTypeConfig.panel.block();
            if (firstPageOnly) {
                blockConfig.options.splice(0, 0, {
                    display: 'Only Show On First Page',
                    group: blockConfig.group,
                    fullWidth: true,
                    name: 'renderOnlyFirst',
                    type: 'checkbox',
                    value: false
                });
            }
            return blockConfig;
        },
        description: (defaultDesign) => TypeConfig._addLineOptions(LabelValueTypeConfig.panel.description(defaultDesign)),
        label: (defaultDesign) => TypeConfig._addLineOptions(LabelValueTypeConfig.panel.label(defaultDesign || Utilities.wrapTextForEditor({ text: 'Signature:' }))),
        style: LabelValueTypeConfig.panel.style,
        value: (defaultDesign) => TypeConfig._addLineOptions(LabelValueTypeConfig.panel.value(defaultDesign || Utilities.wrapTextForEditor({ text: 'Date:' })))
    },
    processLineOptions: (config, displayType) => {
        let label = '';
        let labelStyle = '';
        if (config.design != undefined) {
            if (config.labelSpacing && config.labelSpacing.value && config.labelSpacing.value.length > 0) {
                labelStyle += `${displayType == 'rows' || config.extendLine == true ? 'padding-bottom' : 'padding-right'}:${config.labelSpacing.value}${config.labelSpacing.unit};`
            }
            if (config.extendLine == true) {
                label = config.design || '&nbsp;';
            } else {
                label = `<td><div style="display:inline-block;white-space:nowrap;${labelStyle}">${config.design || '&nbsp;'}</div></td>`
            }
        }
        let borderWidth = '1px';
        if (config.lineWidth && config.lineWidth.value && config.lineWidth.value.length > 0) {
            borderWidth = `${config.lineWidth.value}${config.lineWidth.unit}`;
        }
        let style = `border-bottom-style:solid;border-bottom-width:${borderWidth};display:inline-block;width:100%;`
        if (config.lineColor) {
            style += `border-bottom-color:${config.lineColor};`
        }
        let content;
        if (config.extendLine == true) {
            content = `<td style="width:100%"><div style="${style}${labelStyle}">${label}</div></td>`;
        } else {
            content = `${label}<td style="width:100%"><div style="${style}">&nbsp;</div></td>`;
        }
        return `<table border="0" cellpadding="0" cellspacing="0" style="width:100%;"><tbody><tr>${content}</tr></tbody></table>`
    }
}

export {
    Signature as Component,
    TypeConfig
};